import { render } from "./auth.vue?vue&type=template&id=603229f2&scoped=true&ts=true"
import script from "./auth.vue?vue&type=script&lang=ts"
export * from "./auth.vue?vue&type=script&lang=ts"

import "./auth.vue?vue&type=style&index=0&id=603229f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603229f2"]])

export default __exports__